<template>
    <div :class="styleClass">
        <template>
            <button class="button cursor-pointer" @click.prevent="disconnectWallet" v-if="userAuthenticated"
                    :disabled="loading">
                <template v-if="loading">
                    <spinner-component :color="'text-light'"></spinner-component>
                    Disconnecting, please wait...
                </template>
                <span v-else>Disconnect Wallet</span>
            </button>

            <button class="button cursor-pointer action" @click.prevent="connectWallet" :disabled="loading" v-else>
                <template v-if="loading">
                    <spinner-component :color="'text-light'"></spinner-component>
                    Connecting, please wait...
                </template>
                <span v-else>Connect your wallet</span>
            </button>
        </template>

        <sweet-modal overlay-theme="dark" ref="qrCodeModal">
            <h4 class="py-2" slot="title">Connect your wallet</h4>
            <div class="text-center">
                <a :href="mobileLink" class="mb-5 d-block">Click on this link to sign in with Xumm</a>

                <p class="mb-5">or scan this code in your XUMM app</p>

                <img :src="qrCode" alt="Qr Code">
            </div>
        </sweet-modal>
    </div>
</template>

<script>
import { SweetModal, SweetModalTab } from 'sweet-modal-vue'
import SpinnerComponent from "./SpinnerComponent";

export default {
    name: "ConnectWallet",

    props: {
        channel: String,
        signedIn: Boolean,
        route: String,
        styleClass: {
            type: String,
            default: 'mb-5'
        },
    },

    components: {
        SweetModal,
        SweetModalTab,
        SpinnerComponent
    },

    data() {
        return {
            loading: false,
            upgradingToken: false,
            qrCode: null,
            mobileLink: null,
            userAuthenticated: this.signedIn,
            sessionChannel: this.channel,
        }
    },

    watch: {
        signedIn: {
            handler(newValue) {
                this.userAuthenticated = newValue
            },
            immediate: true
        },

        channel: {
            handler(newValue) {
                this.sessionChannel = newValue
            },
            immediate: true
        }
    },

    methods: {
        connectWallet() {
            this.loading = true
            axios.post('/connect-wallet', {route: this.route})
                .then((response) => {
                    this.loading = false
                    if(response.data.qrCode) {
                        this.qrCode = response.data.qrCode
                        this.mobileLink = response.data.mobileLink
                        this.$refs.qrCodeModal.open()
                    }
                    window.Echo.channel(this.sessionChannel)
                        .listen('XummMessageReceived', (e) => {
                            if(e.message.connected) {
                                this.$refs.qrCodeModal.close()
                                this.userAuthenticated = true
                                this.sessionChannel = e.message.channel
                                this.$emit('signedIn')
                            } else if(!e.message.connected) {
                                this.$refs.qrCodeModal.close()
                                this.userAuthenticated = false
                                this.sessionChannel = e.message.channel
                                Toast.fire({
                                    icon: 'error',
                                    title: 'Xumm sign request rejected'
                                })
                            }
                        });
                })
                .catch((error) => {
                    this.loading = false
                    Swal.fire({
                        icon: 'error',
                        text: error.response.data.message
                    })
                })
        },

        disconnectWallet() {
            this.loading = true
            axios.post('/disconnect-wallet')
                .then((response) => {
                    this.loading = false
                    this.userAuthenticated = false
                    this.sessionChannel = response.data.channel
                    this.$emit('signedOut', response.data.channel)
                })
                .catch((error) => {
                    this.loading = false
                    Swal.fire({
                        icon: 'error',
                        text: error.response.data.message
                    })
                })
        },

    }
}
</script>

<style lang="scss">
button {
    margin-top: unset !important;
    font-size: 0.9375rem;
}
.cursor-pointer {
    cursor: pointer;
}
.py-2 {
    padding: 8px 0;
}
.text-center {
    text-align: center;
}
.sweet-modal-overlay {
    .sweet-modal {
        .sweet-title {
            h4 {
                text-transform: capitalize;
            }
        }
        .sweet-box-actions {
            .sweet-action-close {
                width: unset !important;
                height: unset !important;
                padding: 5px !important;
            }
        }
    }
}
</style>
